/* Cozy Home – Sonbahar dokunuslari (v2, gercekci yapraklar)
   1) Yaprak animasyonu: sayfa yuklendikten sonra bir kez, ~9 sn, sonra DOM'dan silinir.
      Hareket azaltma tercihi acikse calismaz. Mobilde 9, masaustunde 16 yaprak; 3 derinlik katmani.
   2) "cozy autumn" rozeti: /collections/sonbahar icindeki urun kartlarina eklenir (1 saat onbellek).
   Kapatmak icin: window.cozyAutumn = { leaves:false, badge:false } */
(function () {
  var cfg = Object.assign({ leaves: true, badge: true, collection: 'sonbahar', badgeText: 'cozy sonbahar', once: false }, window.cozyAutumn || {});
  /* Yapraklar ve rozet tum sayfalarda acik. Kapatmak icin Custom Liquid'de leaves:'off' / badge:'off' yazin. */
  cfg.leaves = cfg.leaves !== 'off'; cfg.badge = cfg.badge !== 'off';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Gercek yaprak siluetleri (viewBox 0 0 100 100) */
  var SHAPES = {
    maple: 'M50 6 L57 24 L72 14 L68 34 L88 30 L76 46 L94 54 L74 60 L84 78 L64 70 L60 92 L50 76 L40 92 L36 70 L16 78 L26 60 L6 54 L24 46 L12 30 L32 34 L28 14 L43 24 Z',
    oak:   'M50 4 C58 10 62 18 58 26 C68 24 76 30 72 40 C82 42 86 52 78 58 C86 64 84 76 74 78 C76 88 66 94 58 88 C56 96 44 96 42 88 C34 94 24 88 26 78 C16 76 14 64 22 58 C14 52 18 42 28 40 C24 30 32 24 42 26 C38 18 42 10 50 4 Z',
    birch: 'M50 4 C74 14 84 40 76 62 C70 80 60 92 50 96 C40 92 30 80 24 62 C16 40 26 14 50 4 Z',
    elm:   'M50 4 C70 8 86 30 82 54 C78 74 64 90 50 96 C36 90 22 74 18 54 C14 30 30 8 50 4 Z',
    chestnut: 'M50 2 C62 14 70 34 66 56 C64 72 58 86 50 98 C42 86 36 72 34 56 C30 34 38 14 50 2 Z'
  };
  var VEINS = 'M50 96 L50 20 M50 44 L30 30 M50 44 L70 30 M50 62 L26 50 M50 62 L74 50 M50 78 L34 70 M50 78 L66 70';
  /* Dogal sonbahar tonlari: [acik, koyu] */
  var COLORS = [['#E8A33C','#B5661C'], ['#D9622B','#8E3A14'], ['#C9A227','#8A6A12'], ['#B23A2A','#6E1F15'], ['#9A8B2E','#5F5418'], ['#E07B39','#A14A1A'], ['#C4572E','#7A2E12'], ['#D8B04A','#9C7A1E']];

  function leaf(i, layer) {
    var keys = Object.keys(SHAPES), shape = SHAPES[keys[i % keys.length]];
    var col = COLORS[i % COLORS.length], id = 'cl' + i + Math.floor(Math.random() * 1e6);
    var el = document.createElement('span'); el.className = 'cozy-leaf cozy-leaf--l' + layer;
    el.innerHTML =
      '<svg viewBox="0 0 100 100" width="100%" height="100%"><defs><linearGradient id="' + id + '" x1="0" y1="0" x2="1" y2="1">' +
      '<stop offset="0" stop-color="' + col[0] + '"/><stop offset="1" stop-color="' + col[1] + '"/></linearGradient></defs>' +
      '<path d="' + shape + '" fill="url(#' + id + ')"/>' +
      '<path d="' + VEINS + '" stroke="' + col[1] + '" stroke-opacity=".55" stroke-width="2" stroke-linecap="round" fill="none"/>' +
      '<path d="M50 96 L52 110" stroke="' + col[1] + '" stroke-width="3" stroke-linecap="round"/></svg>';
    var size = layer === 1 ? 18 + Math.random() * 10 : layer === 2 ? 28 + Math.random() * 14 : 40 + Math.random() * 18;
    el.style.width = el.style.height = size + 'px';
    el.style.left = (-4 + Math.random() * 104) + '%';
    el.style.animationDelay = (Math.random() * 3.5) + 's, ' + (Math.random() * 2) + 's';
    var fall = layer === 1 ? 11 + Math.random() * 3 : layer === 2 ? 9 + Math.random() * 2.5 : 7 + Math.random() * 2;
    el.style.animationDuration = fall + 's, ' + (2.2 + Math.random() * 1.6) + 's';
    el.style.setProperty('--sway', (40 + Math.random() * 90) * (Math.random() < .5 ? -1 : 1) + 'px');
    el.style.setProperty('--spin', (Math.random() < .5 ? -1 : 1) * (160 + Math.random() * 300) + 'deg');
    el.style.setProperty('--tilt', (Math.random() * 60 - 30) + 'deg');
    return el;
  }

  function leaves() {
    if (!cfg.leaves || reduce) return;
    try { if (cfg.once === 'session' && sessionStorage.getItem('cozyLeavesSeen')) return; sessionStorage.setItem('cozyLeavesSeen', '1'); } catch (e) {}
    var n = window.innerWidth < 750 ? 14 : 24;
    var wrap = document.createElement('div'); wrap.className = 'cozy-leaves'; wrap.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < n; i++) wrap.appendChild(leaf(i, 1 + (i % 3)));
    document.body.appendChild(wrap);
    setTimeout(function () { wrap.classList.add('is-ending'); }, 13500);
    setTimeout(function () { wrap.parentNode && wrap.parentNode.removeChild(wrap); }, 15500);
  }

  function badge() {
    if (!cfg.badge) return;
    var key = 'cozyAutumnHandles:v2', handles = null;
    try { var c = JSON.parse(sessionStorage.getItem(key) || 'null'); if (c && Date.now() - c.t < 1200000) handles = c.h; } catch (e) {}
    var ICON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2c5 2 9 7 9 12 0 4-3 7-7 7-2 0-3-.6-4-1.4L5 23l-1-1 3.4-5C6.6 16 6 15 6 13 6 8 8 4 12 2z" fill="currentColor"/><path d="M12 6v12M12 11l-3-2M12 14l3-2" stroke="#fff" stroke-width="1.4" stroke-linecap="round" fill="none" opacity=".85"/></svg>';
    function makeBadge(extra) {
      var b = document.createElement('span'); b.className = 'cozy-autumn-badge' + (extra ? ' ' + extra : '');
      b.innerHTML = ICON + '<span>' + cfg.badgeText + '</span>';
      return b;
    }
    function apply(list) {
      var set = {}; list.forEach(function (h) { set[h] = 1; });
      document.querySelectorAll('.card-wrapper, .card, .product-card').forEach(function (card) {
        if (card.querySelector('.cozy-autumn-badge')) return;
        var a = card.querySelector('a[href*="/products/"]'); if (!a) return;
        var m = a.getAttribute('href').match(/\/products\/([^\/?#]+)/); if (!m || !set[m[1]]) return;
        var media = card.querySelector('.card__media, .media-wrapper, .card__inner') || card;
        if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
        media.appendChild(makeBadge());
      });
      /* Urun sayfasi: baslik ustune */
      var pm = location.pathname.match(/\/products\/([^\/?#]+)/);
      if (pm && set[pm[1]] && !document.querySelector('.cozy-autumn-badge--pdp')) {
        var title = document.querySelector('.product__info-container .product__title, .product__info-container h1, .product__title');
        if (title) title.parentNode.insertBefore(makeBadge('cozy-autumn-badge--pdp'), title);
      }
    }
    function watch(list) {
      apply(list);
      if (!window.MutationObserver) return;
      var t = null;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { apply(list); }, 150); })
        .observe(document.body, { childList: true, subtree: true });
    }
    if (handles) return watch(handles);
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var all = [];
    function page(n) {
      return fetch(root + 'collections/' + cfg.collection + '/products.json?limit=250&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          var ps = (d && d.products) || [];
          ps.forEach(function (p) { all.push(p.handle); });
          if (ps.length === 250 && n < 8) return page(n + 1);
        });
    }
    page(1).then(function () {
      if (!all.length) return;
      try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), h: all })); } catch (e) {}
      watch(all);
    }).catch(function () {});
  }

  function start() { leaves(); badge(); }
  function schedule() { var idle = window.requestIdleCallback || function (fn) { setTimeout(fn, 1500); }; idle(start, { timeout: 4000 }); }
  if (document.readyState === 'complete') schedule(); else window.addEventListener('load', schedule, { once: true });
})();
